import { getFormValues, isEmail, isKennitala, isPhoneNumber } from 'helpers';

type NetbankFormValues = {
	applicantIsOnlyUser: boolean;
	keyUserSsn?: string;
	keyUserEmail?: string;
	keyUserPhone?: string;
	supervisorSsn?: string;
	supervisorEmail?: string;
	[key: string]: string | boolean | undefined;
};

export function getNetbankFormValues(applicantIsOnlyUser = true): NetbankFormValues {
	const form = document.querySelector('form');
	return form ? { ...getFormValues(form), applicantIsOnlyUser } : { applicantIsOnlyUser };
}

export function getNetbankFormErrors(values: NetbankFormValues) {
	return values.applicantIsOnlyUser ? {} : validateNetbankForm(values);
}

export const validators = {
	keyUserSsn: (value: string) => (isKennitala(value) ? {} : { keyUserSsn: 'error_wrong_ssn_length' }),
	keyUserEmail: (value: string) => (isEmail(value) ? {} : { keyUserEmail: 'error_email' }),
	keyUserPhone: (value: string) => (isPhoneNumber(value) ? {} : { keyUserPhone: 'error_phone_number' }),
	supervisorSsn: (value: string) => (isKennitala(value) ? {} : { supervisorSsn: 'error_wrong_ssn_length' }),
	supervisorEmail: (value: string) => (isEmail(value) ? {} : { supervisorEmail: 'error_email' })
};

export function validateNetbankForm(values: NetbankFormValues) {
	if (values.applicantIsOnlyUser) return {};

	const errors: Record<string, string> = {};
	for (const key of Object.keys(validators)) {
		const validator = (validators as Record<string, (value: string) => Record<string, string>>)[key];
		const value = values[key];
		Object.assign(errors, validator(value as string));
	}
	return errors;
}

export function buildNetbankPayload(values: NetbankFormValues, ssn: string) {
	return {
		ssn,
		corporateUsers: {
			masterUser: {
				kennitala: values.keyUserSsn ?? '',
				email: values.keyUserEmail ?? '',
				phoneNumber: values.keyUserPhone ?? ''
			},
			auditUser: {
				kennitala: values.supervisorSsn ?? '',
				email: values.supervisorEmail ?? ''
			}
		}
	};
}
